export default __webpack_public_path__ + "static/media/js.ae3d5265.png";